'use client';
import React from 'react';
import SpecificationData from '../../SpecificationData';

export default function Location(props: any) {
  const { t } = props;
  const tabContent = [
    {
      type: 'location',
      heading: t['beachHouseLocationHeading'],
      description: t['beachHouseLocationContent'],
      listElement: t['beachHouseLocationCards'],
      images: props.tabImages,
      mobImages: props.mobTabImages,
    },
  ];
  return (
    <>
      {/* @ts-ignore */}
      <SpecificationData t={t} tabs={tabContent} />
    </>
  );
}
